import { graphql } from "react-relay";

export const edit_enrolment = graphql`
  mutation EditEnrolmentMutation($input: EditEnrolmentInput!) {
    editEnrolment(input: $input) {
      success
      errors
      enrolment {
        id
        school {
          id
        }
        pupilFirstName
        pupilLastName
        schoolYear
        schoolClass
        instrument
        lessonStage
        lessonType
        parentName
        parentEmail
        parentPhoneNumber
        hasInvalidParentPhoneNumber
        adminNotes
        pupilNotes
        positionInWaitingList
        status
        createdTimestamp
        enroledTimestamp
        archivedTimestamp
        lastOfferedTimestamp
        offers {
          edges {
            node {
              id
              offerAccepted
              archived
            }
          }
        }
      }
      updatedEnrolmentsInWaitingList {
        id
        positionInWaitingList
      }
    }
  }
`;
